import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type { IReview } from '../home.interface';
interface IProps {
  review: IReview;
  index: number;
}

/* Single Prominent review with image */
export const ProminentReview = t0 => {
  const $ = _c(18);
  const {
    review
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute -left-4 top-1 w-9"><Image src="/images/icons/ic_inverted_comma.svg" alt="comma" width={36} height={36} /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="relative z-10">{t1}<div className="absolute left-5 top-1 h-32 w-9"><Image src="/images/icons/ic_inverted_comma.svg" alt="comma" width={36} height={36} /></div></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== review.text) {
    t3 = <div className="z-20 pt-4 text-lg font-normal text-[#3D3E40]">{review.text}</div>;
    $[2] = review.text;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== review.name) {
    t4 = <div className="z-20 mt-2 text-lg font-medium text-[#3D3E40]">{review.name}</div>;
    $[4] = review.name;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== review.occupation) {
    t5 = <div className="z-20 text-lg text-[#555659]">{review.occupation}</div>;
    $[6] = review.occupation;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t4 || $[10] !== t5) {
    t6 = <div className="mt-12 flex flex-col">{t2}{t3}{t4}{t5}</div>;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = review.imageUrl || "avatar image";
  let t8;
  if ($[12] !== review.name || $[13] !== t7) {
    t8 = <Image src={t7} alt={review.name} className="absolute -top-12 left-[50%] aspect-square w-24 translate-x-[-50%] rounded-full bg-[#EBF7FF]" width={96} height={96} />;
    $[12] = review.name;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t8) {
    t9 = <div className="relative rounded-lg bg-white px-4 pb-6 md:px-6 lg:max-w-[40%] lg:px-10">{t6}{t8}</div>;
    $[15] = t6;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};